export default __webpack_public_path__ + "static/media/432hz-whale-song.44a89ebc.mp3";